//全局搜索——历史搜索记录
export default {
    count:0,
    data:[],
    title:''
}
